import { h } from 'preact'
import { Author } from './index'
import UserAvatar from '../User/UserAvatar'
import TopicReplyCount from '../ui-components/TopicReplyCount'
import ClampLines from 'react-clamp-lines'
import htmlParser from '../utils/htmlParser'
import LazyLoader from '../lazy-loading/LazyLoader'
import { common } from '../common'

interface Props {
  content: string,
  featuredImage: string,
  id: number,
  title: string,
  url:string,
  fullWidth: boolean,
  index: number,
  replyCount: number,
  customClass: string,
  label: string,
  createdAt: string,
  author: Author
}

const FeaturedProductUpdateView = (props: Props) => {
  const { label = '', replyCount, title, url, author, featuredImage, content, fullWidth, customClass = '', createdAt } = props
  const createTime = new Date(createdAt).getTime()

  return (
    <li className={`featured-topic ${fullWidth ? 'featured-topic--full-width' : ''} ${featuredImage && 'featured-topic--featured-image'} ${customClass}`}>
      <a href={url} className='featured-topic__url card-widget-wrapper'>
        <div>
          {
            label && (
              <span className='topic__content-type-pill pill pill--uppercase pill--article qa-content-type-pill'>
                {label}
              </span>
            )
          }
          {
            featuredImage && <LazyLoader type='background' src={featuredImage} classNames='featured-topic__hero' />
          }
        </div>
        <div className='featured-topic__title'>
          <h3
            className={`featured-topic__heading card-widget-title ${!featuredImage && label ? 'featured-topic__heading--no-image' : ''}`}>
            {title}
          </h3>
          {
            window.inSidedData?.device !== 'mobile' && (fullWidth || !featuredImage) &&
              <p className='card-widget-text'>
                <ClampLines lines={3} text={htmlParser.stripHtml(content)} buttons={false} />
              </p>
          }
          <div className='post-meta__container'>
            <div className='post-meta__container--left'>
              <UserAvatar user={author} extraClass='avatar avatar--XS' />
              <span className='thread-meta-item__date'>
              { common.relativeDate(createTime) }
            </span>
            </div>
            <div className='post-meta__container--right'>
              <TopicReplyCount replyCount={replyCount} />
            </div>
          </div>
        </div>
      </a>
    </li>
  )
}

export default FeaturedProductUpdateView
